import {
    HeaderActionArea,
    SelectField,
    IconButton,
    Option,
} from '@deere/fuel-react';
import SettingsIconMui from '@mui/icons-material/Settings';
import { AdminContext } from '../../context/AdminContext';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalContentText,
    ModalTitle,
} from '@deere/fuel-react';

export const AdminHeader = () => {
    const navigate = useNavigate();
    const {
        selectedAdminGroup,
        availableAdminGroups,
        loading,
        error,
        isJobFormDirty,
        changeSelectedAdminGroup,
    } = useContext(AdminContext);
    const [pendingAdminGroup, setPendingAdminGroup] = useState(null);

    const adminGroupHandler = (event) => {
        const nextAdminGroup = event.target.value;
        if (isJobFormDirty) {
            setPendingAdminGroup(nextAdminGroup);
        } else {
            changeSelectedAdminGroup(nextAdminGroup);
        }
    };

    const cancelAdminGroupChange = () => setPendingAdminGroup(null);

    const confirmAdminGroupChange = () => {
        if (pendingAdminGroup == null) {
            return;
        }
        changeSelectedAdminGroup(pendingAdminGroup);
        setPendingAdminGroup(null);
    };

    return (
        <>
            <Modal
                open={pendingAdminGroup !== null}
                onClose={cancelAdminGroupChange}
                aria-labelledby="admin-group-change-title"
                aria-describedby="admin-group-change-description"
            >
                <ModalTitle id="admin-group-change-title">
                    Change admin group?
                </ModalTitle>
                <ModalContent>
                    <ModalContentText id="admin-group-change-description">
                        You have unsaved job data. Changing the admin group will
                        discard it. Do you want to continue?
                    </ModalContentText>
                </ModalContent>
                <ModalActions>
                    <Button
                        onClick={cancelAdminGroupChange}
                        variant="secondary"
                    >
                        Cancel
                    </Button>
                    <Button onClick={confirmAdminGroupChange} variant="primary">
                        Change admin group
                    </Button>
                </ModalActions>
            </Modal>
            {!loading && !error && availableAdminGroups.length > 1 && (
                <SelectField
                    aria-label="Choose a Unit"
                    name="Choose a Unit"
                    value={selectedAdminGroup.adGroup ?? ''}
                    onChange={adminGroupHandler}
                    style={{ maxWidth: '12rem', alignSelf: 'flex-end' }}
                >
                    <Option value="" disabled hidden>
                        Choose a Unit
                    </Option>
                    {availableAdminGroups.map((ag, i) => {
                        return (
                            <Option key={i} value={ag.adGroup}>
                                {ag.displayName}
                            </Option>
                        );
                    })}
                    ;
                </SelectField>
            )}
            <HeaderActionArea>
                <IconButton
                    aria-label="Settings"
                    onClick={() => navigate('/settings')}
                >
                    <SettingsIconMui />
                </IconButton>
            </HeaderActionArea>
        </>
    );
};
